import React from "react";
import { StyledDiv } from "./Section_one.style";
// import Button from "components/Button";
import styled from "styled-components";
import { Button } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
const ParentContainer = styled.div`
  // padding: 180px;
`;
const TextContainer = styled.div`
  text-align: center;
  position: relative;
z-index: 1;
`;
const Title = styled.span`
  display: block;
  color: #fff;
  line-height: 90px;
`;
interface Section_one  {
  background: any;
  title1?:any;
  title2?:any;
  flipHorizontal?:any
}
const Section_one : React.FunctionComponent<Section_one> = (props) => {
  return (
    <>
      <StyledDiv className="homebanner" backgroundimage={props.background} fliphorizontal={props.flipHorizontal}>
        <ParentContainer>
          <div className="container banerrhomeindici">
            <div className="row w-100">
              <div className="col-md-6"></div>
              <div className="col-md-6 ">
                <TextContainer>
                  <Title className="main-heading"> {props.title1}<br/>{props.title2}  </Title>
                  {/* <Button  className="mt-3 clickHere">  Click Here </Button> */}
                </TextContainer>
              </div>
            </div>
          </div>
        </ParentContainer> 
      </StyledDiv>
    </>
  );
};
export default Section_one;